export const messages = {
  en: {
    noticeManage: {
      search: {
        title: 'Search Conditions',
        noticeTypePlaceholder: 'Please select notice type',
        ownerNotice: 'Owner Notice',
        staffNotice: 'Staff Notice',
        statePlaceholder: 'Please select status',
        pendingNotice: 'Pending Notice',
        notifying: 'Notifying',
        noticeComplete: 'Notice Complete',
        titlePlaceholder: 'Please enter notice title',
        startTimePlaceholder: 'Required, please select start time',
        endTimePlaceholder: 'Required, please select end time'
      },
      list: {
        title: 'Notice Information'
      },
      table: {
        noticeId: 'Notice ID',
        title: 'Title',
        noticeType: 'Notice Type',
        startTime: 'Start Time',
        endTime: 'End Time',
        state: 'Status',
        noticeRange: 'Notice Range'
      },
      delete: {
        title: 'Please confirm your operation',
        confirmText: 'Confirm to delete this notice?',
        cancelText: 'Cancel',
        confirmButton: 'Confirm Delete',
        successMessage: 'Delete successfully',
        errorMessage: 'Delete failed'
      },
      fetchError: 'Failed to fetch notice data'
    }
  },
  zh: {
    noticeManage: {
      search: {
        title: '查询条件',
        noticeTypePlaceholder: '请选择公告类型',
        ownerNotice: '业主通知',
        staffNotice: '员工通知',
        statePlaceholder: '请选择状态',
        pendingNotice: '待通知',
        notifying: '通知中',
        noticeComplete: '通知完成',
        titlePlaceholder: '请输入公告标题',
        startTimePlaceholder: '必填，请填写开始时间',
        endTimePlaceholder: '必填，请填写结束时间'
      },
      list: {
        title: '公告信息'
      },
      table: {
        noticeId: '公告ID',
        title: '标题',
        noticeType: '公告类型',
        startTime: '开始时间',
        endTime: '结束时间',
        state: '状态',
        noticeRange: '通知范围'
      },
      delete: {
        title: '请确认您的操作',
        confirmText: '确定删除公告？',
        cancelText: '点错了',
        confirmButton: '确认删除',
        successMessage: '删除成功',
        errorMessage: '删除失败'
      },
      fetchError: '获取公告数据失败'
    }
  }
}